import { ADMIN_BASE_BATH } from '../variables';

export const PermissionTypes = {
  NOTHING: 0,
  READ: 1,
  READWRITE: 2,
};

export const RoutesMapping = {
  translations: 'translations',
  roles: 'roles',
  workers: 'workers',
  admins: 'admins',
  files: 'files',
  dealRooms: 'dealRooms',
  chats: 'chats',
  clients: 'clients',
};

export const RoutesMappingTranslationKey = {
  translations: 'menu.translations',
  roles: 'menu.roles',
  workers: 'menu.workers',
  admins: 'menu.admins',
  files: 'menu.files',
  dealRooms: 'menu.dealRooms',
  chats: 'menu.chats',
  clients: 'menu.clients',
};

export const RouteWisePermission = {
  [`${ADMIN_BASE_BATH}/translations`]: RoutesMapping.translations,
  [`${ADMIN_BASE_BATH}/roles`]: RoutesMapping.roles,
  [`${ADMIN_BASE_BATH}/workers`]: RoutesMapping.workers,
  [`${ADMIN_BASE_BATH}/workers/personal-info`]: RoutesMapping.workers,
  [`${ADMIN_BASE_BATH}/workers/personal-info/:id`]: RoutesMapping.workers,
  [`${ADMIN_BASE_BATH}/workers/chat-info/:id`]: RoutesMapping.workers,
  [`${ADMIN_BASE_BATH}/workers/channel-info/:id/:channelId`]: RoutesMapping.workers,
  [`${ADMIN_BASE_BATH}/workers/note-info/:id`]: RoutesMapping.workers,
  [`${ADMIN_BASE_BATH}/admins`]: RoutesMapping.admins,
  [`${ADMIN_BASE_BATH}/admins/personal-info`]: RoutesMapping.admins,
  [`${ADMIN_BASE_BATH}/admins/personal-info/:id`]: RoutesMapping.admins,
  [`${ADMIN_BASE_BATH}/files`]: RoutesMapping.files,
  [`${ADMIN_BASE_BATH}/deal-rooms`]: RoutesMapping.dealRooms,
  [`${ADMIN_BASE_BATH}/deal-rooms/deal-room-info`]: RoutesMapping.dealRooms,
  [`${ADMIN_BASE_BATH}/deal-rooms/deal-room-info/:id`]: RoutesMapping.dealRooms,
  [`${ADMIN_BASE_BATH}/deal-rooms/deal-room-attributes/:id`]: RoutesMapping.dealRooms,
  [`${ADMIN_BASE_BATH}/deal-rooms/insight/:id`]: RoutesMapping.dealRooms,
  [`${ADMIN_BASE_BATH}/deal-rooms/engagement`]: RoutesMapping.dealRooms,
  [`${ADMIN_BASE_BATH}/chats`]: RoutesMapping.chats,
  [`${ADMIN_BASE_BATH}/chats/:dealRoomId`]: RoutesMapping.chats,
  [`${ADMIN_BASE_BATH}/clients`]: RoutesMapping.clients,
  [`${ADMIN_BASE_BATH}/clients/deal-room-info`]: RoutesMapping.clients,
  [`${ADMIN_BASE_BATH}/clients/deal-room-info/:id`]: RoutesMapping.clients,
};
